<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-card elevation="0" class="px-5 py-5" color="transparent">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="registerAnimal"
        >
          <v-card-text>
            <div class="d-flex">
              <div>
                <h2>
                  {{ $t("animal.animalRegistration") }}
                </h2>
                <div class="py-4">
                  <sup class="red--text">*</sup> {{ $t("mandatory") }}
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                outlined
                exact
                class="mr-2"
                :to="{ name: 'Animals' }"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn :disabled="!valid" type="submit" color="primary">{{
                $t("register")
              }}</v-btn>
            </div>
            <div
              class="py-5 px-5"
              style="background: #ffffff; border-radius: 5px"
            >
              <v-expansion-panels focusable flat class="mt-5" v-model="panel">
                <v-expansion-panel
                  class="general-information"
                  :class="
                    isGeneralInfoFulfilled
                      ? 'general-information-fulfilled'
                      : 'general-information-not-fulfilled'
                  "
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    :disable-icon-rotate="isGeneralInfoFulfilled"
                  >
                    {{ $t("animal.generalInfo") }}
                    <template v-slot:actions v-if="isGeneralInfoFulfilled">
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="animal-from">
                      <div>
                        <v-row class="pa-5">
                          <!-- <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >Farm <span class="red--text">*</span></label
                            >
                            <v-select
                              :error-messages="errors.farm"
                              :items="getFarmList"
                              :rules="animalRules.farm"
                              dense
                              item-text="farmName"
                              item-value="id"
                              outlined
                              placeholder="Select Farm"
                              v-model="animalToAdd.farmId"
                            />
                          </v-col> -->
                          <!-- <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">Farm Type <v-icon class="mb-1">
                                mdi-alert-circle-outline</v-icon></label>
                            <v-select :items="farmTypes" item-text="name"
                              item-value="id" outlined dense :error-messages="errors.tagType"
                              v-model="animalToAdd.farmTypeId"
                              :rules="animalRules.tagType"></v-select>
                          </v-col> -->
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Species") }}
                              <span class="red--text">*</span>
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.species") }}
                                </span>
                              </v-tooltip>
                            </label>

                            <div class="d-flex">
                              <v-select
                                :items="getSpecies"
                                :error-messages="errors.species"
                                :rules="animalRules.species"
                                class="mr-1"
                                dense
                                item-text="name"
                                item-value="id"
                                outlined
                                placeholder="Select Species"
                                v-model="animalToAdd.speciesId"
                              />
                            </div>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Type") }}
                              <span class="red--text">*</span>
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.speciesType") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <div class="d-flex">
                              <v-select
                                :items="getSpeciesTypes"
                                item-text="name"
                                item-value="id"
                                :error-messages="errors.speciesType"
                                :rules="animalRules.speciesType"
                                outlined
                                dense
                                :placeholder="$t('speciesType')"
                                v-model="animalToAdd.speciesTypeId"
                              />
                            </div>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Gender") }}
                              <span class="red--text">*</span>
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.gender") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-select
                              outlined
                              dense
                              :placeholder="$t('selectGender')"
                              :items="genders"
                              :error-messages="errors.gender"
                              :rules="animalRules.gender"
                              v-model="animalToAdd.gender"
                            ></v-select>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Breed") }}
                              <span class="red--text">*</span>
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.breed") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-select
                              outlined
                              dense
                              :placeholder="
                                $t('geneticsAndBreeding.selectBreed')
                              "
                              :items="getBreeds"
                              item-text="name"
                              item-value="id"
                              :error-messages="errors.breed"
                              :rules="animalRules.breed"
                              v-model="animalToAdd.breedId"
                            ></v-select>
                          </v-col>
                          <v-col
                            lg="3"
                            md="6"
                            xs="6"
                            v-if="animalToAdd.breedId == '9999'"
                          >
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("genoPerformance.breedName") }}
                              <span class="red--text">*</span></label
                            >
                            <v-text-field
                              :rules="animalRules.breedName"
                              v-model="breedName"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.ClassUse") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.classUse") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-autocomplete
                              @input="onClassSelect"
                              v-model="animalToAdd.classId"
                              :items="getClasses"
                              :search-input.sync="classSearch"
                              outlined
                              dense
                              small-chips
                              multiple
                              hide-no-data
                              item-text="name"
                              item-value="id"
                              placeholder="Start typing to search"
                              clearable
                              deletable-chips
                            />
                          </v-col>
                          <v-col
                            lg="3"
                            md="6"
                            xs="6"
                            v-if="
                              animalToAdd.classId &&
                              animalToAdd.classId.includes('9999')
                            "
                          >
                            <label class="subtitle-1 font-weight-medium"
                              >Class/Use Name
                              <span class="red--text">*</span></label
                            >
                            <v-text-field
                              :rules="animalRules.className"
                              v-model="className"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label
                              class="subtitle-1 font-weight-medium nowrap-label"
                            >
                              {{ $t("animal.AnimalCategoryStage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.generalInfoFrom.animalCategoryStage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-select
                              outlined
                              dense
                              placeholder="Select Category"
                              :items="getCategories"
                              item-text="name"
                              item-value="id"
                              v-model="animalToAdd.animalCategoryId"
                            ></v-select>

                            <!-- <v-autocomplete
                              @input="onCategorySelect"
                              v-model="animalToAdd.animalCategoryId"
                              :items="getCategories"
                              :search-input.sync="categorySearch"
                              outlined
                              dense
                              small-chips
                              multiple
                              hide-no-data
                              item-text="name"
                              item-value="id"
                              :placeholder="$t('startTypingSearch')"
                              :error-messages="errors.category"
                              :rules="animalRules.category"
                              clearable
                              deletable-chips
                            /> -->
                            <!-- <v-select outlined dense placeholder="Select Category" :error-messages="errors.category" :rules="animalRules.category"
                              :items="animalCategories" item-text="name" item-value="id" v-model="animalToAdd.animalCategoryId"></v-select> -->
                          </v-col>

                          <v-col
                            lg="3"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="animalToAdd.gender == 'Female'"
                          >
                            <label
                              class="subtitle-1 font-weight-medium nowrap-label"
                              >{{ $t("animal.PregnancyStatus") }}

                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.generalInfoFrom.animalCategoryStage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-select
                              outlined
                              dense
                              placeholder="Select Status"
                              :items="pregnancyStatus"
                              item-text="text"
                              item-value="value"
                              v-model="animalToAdd.pregnancyStatus"
                            ></v-select>
                          </v-col>

                          <v-col
                            lg="3"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="animalToAdd.gender == 'Male'"
                          >
                            <label
                              class="subtitle-1 font-weight-medium nowrap-label"
                              >Bull Type
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.generalInfoFrom.animalCategoryStage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-select
                              outlined
                              dense
                              placeholder="Select Type"
                              :items="bullTypes"
                              item-text="text"
                              item-value="value"
                              v-model="animalToAdd.bullType"
                            ></v-select>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.SelectFarmLocation") }}

                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.assignZone") }}
                                </span>
                              </v-tooltip></label
                            >
                            <div>
                              <v-select
                                outlined
                                dense
                                v-model="animalToAdd.locationId"
                                :items="farmLocationFilter"
                                item-text="address"
                                item-value="id"
                                attach
                                placeholder="Select Farm Location"
                                @change="
                                  fetchLocationZones(animalToAdd.locationId)
                                "
                              >
                              </v-select>
                            </div>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.AssignZone") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.assignZone") }}
                                </span>
                              </v-tooltip></label
                            >
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-text-field
                                    outlined
                                    dense
                                    v-model="zoneSearchTerm"
                                    placeholder="Search"
                                    @input="searchZones"
                                  >
                                  </v-text-field>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                            <div>
                              <v-select
                                outlined
                                dense
                                v-model="animalToAdd.zoneId"
                                :items="filterZones"
                                item-text="geofenceName"
                                item-value="id"
                                attach
                                :placeholder="$t('selectZone')"
                              >
                                >
                                <template v-slot:prepend-item>
                                  <v-list-item>
                                    <v-list-item-content
                                      v-if="animalToAdd.locationId"
                                    >
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="zoneSearchTerm"
                                        placeholder="Search"
                                        @input="searchZones"
                                      >
                                      </v-text-field>
                                      <div>
                                        <v-icon style="color: #00bd73"
                                          >mdi-plus</v-icon
                                        >
                                        <a
                                          href="#"
                                          @click="
                                            showPrimaryGeofenceDialog = true
                                          "
                                          >{{ $t("createNewZone") }}</a
                                        >
                                      </div>
                                    </v-list-item-content>
                                    <v-list-item-content v-else>
                                      <div
                                        class="ml-2 mt-2"
                                        style="color: rgb(255, 18, 18)"
                                      >
                                        Please select location first.
                                      </div>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider class="mt-2"></v-divider>
                                </template>
                              </v-select>
                            </div>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Group") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.generalInfoFrom.group") }}
                                </span>
                              </v-tooltip></label
                            >
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-text-field
                                    outlined
                                    dense
                                    v-model="groupSearchTerm"
                                    placeholder="Search"
                                    @input="searchGroups"
                                  >
                                  </v-text-field>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                            <div>
                              <v-select
                                outlined
                                dense
                                v-model="animalToAdd.groupId"
                                multiple
                                :items="filterGroups"
                                item-text="name"
                                item-value="id"
                                attach
                                placeholder="Select Group"
                              >
                                <template v-slot:prepend-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="groupSearchTerm"
                                        placeholder="Search"
                                        @input="searchGroups"
                                      >
                                      </v-text-field>
                                      <div>
                                        <v-icon style="color: #00bd73"
                                          >mdi-plus</v-icon
                                        >
                                        <a
                                          href="#"
                                          @click="showCreateGroupDialog = true"
                                          >{{
                                            $t(
                                              "geneticsAndBreeding.createNewGroup"
                                            )
                                          }}</a
                                        >
                                      </div>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider class="mt-2"></v-divider>
                                </template>
                              </v-select>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  class="mt-2"
                  :class="
                    isAnimalIdentificationFilled && 'information-fulfilled'
                  "
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    disable-icon-rotate
                  >
                    {{ $t("animal.identification") }}
                    <template
                      v-slot:actions
                      v-if="
                        isAnimalIdentificationFilled ||
                        isAnimalIdentificationMethodFilled
                      "
                    >
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <v-row class="pa-3">
                        <v-row>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.AnimalNameNickname") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.livestockNameNickname"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              outlined
                              dense
                              placeholder="Type Name"
                              v-model="animalToAdd.livestockName"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.GovtRegistrationNumber") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.governmentRegistrationNumber"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-text-field
                              type="text"
                              outlined
                              dense
                              placeholder="e.g. DM0003992"
                              append-icon="mdi-credit-card-scan"
                              v-model="animalToAdd.govRegistrationNo"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.DateofRegistration") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.dateOfRegistration"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-menu
                              v-model="dateOfRegistrationModel"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="animalToAdd.dateOfRegistration"
                                  append-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  v-on:click:append="
                                    dateOfRegistrationModel = true
                                  "
                                  outlined
                                  dense
                                  placeholder="Select date"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="animalToAdd.dateOfRegistration"
                                @input="dateOfRegistrationModel = false"
                                :max="getTodayDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-row>
                      <v-row>
                        <v-col
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          style="padding-bottom: 10px !important"
                        >
                          <label class="subtitle-1 font-weight-medium">
                            {{ $t("animal.IdentificationMethod") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-help-circle-outline
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  $t(
                                    "animal.identificationInfo.identificationMethod"
                                  )
                                }}
                              </span>
                            </v-tooltip>
                          </label>
                        </v-col>
                      </v-row>
                      <v-row
                        v-for="(
                          ident, index
                        ) in animalToAdd.identificationMethodsArr"
                        :key="index"
                        class="additional-ids"
                      >
                        <v-col lg="4" md="4" sm="4" xs="4">
                          <div class="d-flex justify-space-between">
                            <label
                              class="subtitle-1 font-weight-medium nowrap-label"
                            >
                              {{ $t("animal.AdditionalIdentificationMethod") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.additionalIDMethod"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <!-- <a @click="removeIdentificationArr(index)" v-if="index > 0" style="color: #ff6176; text-decoration: none;">Remove</a> -->
                            <!-- <a
                              @click="addToIdentificationArr"
                              style="color: #70a4d3; text-decoration: none"
                              >Add More</a
                            > -->
                          </div>
                          <v-select
                            outlined
                            dense
                            :placeholder="$t('selectIdentity')"
                            :items="
                              getDropDownDataAnimalIdentification.additionalIdentificationMethod
                            "
                            item-text="name"
                            item-value="id"
                            v-model="ident.additionalIdentificationMethodId"
                          ></v-select>
                        </v-col>

                        <template>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 1"
                          >
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.TagIDNumber") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.identificationInfo.tagIDNumber")
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-text-field
                              type="text"
                              :placeholder="$t('enterIdNumber')"
                              outlined
                              dense
                              v-model="ident.idNumber"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="
                              ident.additionalIdentificationMethodId == 1 ||
                              ident.additionalIdentificationMethodId == 3
                            "
                          >
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.ChipNumber") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.identificationInfo.chipNumber")
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-text-field
                              type="text"
                              :placeholder="$t('enterChipNumber')"
                              outlined
                              dense
                              v-model="ident.chipNumber"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 5"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.TagNumber") }}
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. DM0003992"
                              outlined
                              dense
                              v-model="ident.tagNumber"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 1"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.TagCategory") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.identificationInfo.tagCategory")
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-select
                              outlined
                              dense
                              :placeholder="$t('selectTagCategory')"
                              :items="
                                getDropDownDataAnimalIdentification.tagCategory
                              "
                              item-text="name"
                              item-value="id"
                              v-model="ident.tagCategoryId"
                            ></v-select>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 2"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.TattooName") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.tattooNameImage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >
                            <v-text-field
                              type="text"
                              :placeholder="$t('enterTattooName')"
                              outlined
                              dense
                              v-model="ident.tatooName"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 4"
                          >
                            <label class="subtitle-1 font-weight-medium">{{
                              $t("code")
                            }}</label>
                            <v-text-field
                              type="text"
                              :placeholder="$t('enterCode')"
                              outlined
                              dense
                              v-model="ident.code"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 6"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.BrandNameNumber") }}
                            </label>
                            <v-text-field
                              type="text"
                              :placeholder="$t('brandNameNumber')"
                              outlined
                              dense
                              v-model="ident.brandName"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId !== 4"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.Positionplace") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.positionPlace"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              :placeholder="$t('positionPlace')"
                              outlined
                              dense
                              v-model="ident.position"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="4"
                            sm="4"
                            xs="4"
                            v-if="ident.additionalIdentificationMethodId == 1"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.TagColor") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.identificationInfo.tagColor") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              :placeholder="$t('tnterTagColor')"
                              outlined
                              dense
                              v-model="ident.tagColor"
                            ></v-text-field>
                          </v-col>

                          <v-col lg="4" md="4" sm="4" xs="4">
                            <label
                              v-if="ident.additionalIdentificationMethodId == 2"
                              class="subtitle-1 font-weight-medium"
                            >
                              {{ $t("animal.TattooImage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.identificationInfo.tattoImage")
                                  }}
                                </span>
                              </v-tooltip></label
                            >

                            <label
                              v-else-if="
                                ident.additionalIdentificationMethodId == 3
                              "
                              class="subtitle-1 font-weight-medium"
                            >
                              {{ $t("animal.MicrochipImage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.microchipImage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >

                            <label
                              v-else-if="
                                ident.additionalIdentificationMethodId == 4
                              "
                              class="subtitle-1 font-weight-medium"
                            >
                              {{ $t("animal.EarNotchingImage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.earNotchingImage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >

                            <label
                              v-else-if="
                                ident.additionalIdentificationMethodId == 6
                              "
                              class="subtitle-1 font-weight-medium"
                            >
                              {{ $t("animal.SkinBrandingImage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.identificationInfo.skinBrandingImage"
                                    )
                                  }}
                                </span>
                              </v-tooltip></label
                            >

                            <!-- <label v-else class="subtitle-1 font-weight-medium">
                              {{ $t("animal.TagImage") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.identificationInfo.tagImage") }}
                                </span>
                              </v-tooltip></label
                            > -->
                            <!-- <v-text-field
                              style="margin-right: 10px"
                              readonly
                              outlined
                              dense
                              :title="ident.imageUrl?.match(/.*\/(.*)$/)[1]"
                              value=""
                            >
                              <template v-slot:prepend-inner>
                                <div v-if="ident.imageUrl">
                                  <a
                                    href="#"
                                    @click.prevent="showImage(ident.imageUrl)"
                                    >{{ ident.imageUrl.slice(-12) }}</a
                                  >
                                </div>
                              </template>
                              <template v-slot:append>
                                <v-btn
                                  v-if="ident.imageUrl"
                                  @click="
                                    replaceFile(index, 'upload-file-' + index)
                                  "
                                  color="primary"
                                  depressed
                                  text
                                  class="text-capitalize mr-n2"
                                  x-small
                                  >replace</v-btn
                                >
                                <v-btn
                                  v-if="ident.imageUrl"
                                  @click="removeFile(index)"
                                  color="red"
                                  depressed
                                  text
                                  class="text-capitalize mr-n2"
                                  x-small
                                  >{{ $t("remove") }}</v-btn
                                >
                                <v-btn
                                  v-else
                                  @click="opendFile('upload-file-' + index)"
                                  color="primary"
                                  depressed
                                  text
                                  class="text-capitalize mr-n2"
                                  x-small
                                  >{{ $t("Browse") }}</v-btn
                                >
                              </template>
                            </v-text-field> -->
                            <input
                              hidden
                              type="file"
                              :ref="'upload-file-' + index"
                              :for="'upload-file-' + index"
                              :id="'upload-file-' + index"
                              :name="'upload-file' + index"
                              :index="index"
                              @change="
                                e => onAnimalTatooPictureChange(index, e)
                              "
                            />
                            <!-- <label v-if="ident.imageUrl" :for="'supload-file-' + index" :refs="'supload-file-' + index" class="file-btn1">Remove</label> -->
                            <!-- <label v-if="ident.imageUrl" :for="'supload-file-' + index" :refs="'rupload-file-' + index" class="file-btn2">Replace</label> -->
                            <!-- <label  v-else :for="'upload-file-' + index" :refs="'upload-file-' + index" class="file-btn">Browses</label> -->
                            <v-btn
                              text
                              @click="addToIdentificationArr"
                              color="primary"
                            >
                              <v-icon left> mdi-plus-circle-outline </v-icon>
                              {{ $t("addAnother") }}
                            </v-btn>
                          </v-col>
                        </template>

                        <template>
                          <!-- <v-col lg="4" md="4" sm="4" xs="4">
                            <label class="subtitle-1 font-weight-medium"
                              >Tattoo Name/Image</label
                            >
                            <v-text-field
                              outlined
                              dense
                              placeholder="Tattoo Name"
                              :items="
                                getDropDownDataAnimalIdentification.tagCategory
                              "
                              item-text="name"
                              item-value="id"
                              v-model="ident.tattooNameOrImage"
                            ></v-text-field>
                          </v-col> -->
                          <v-col
                            lg="2"
                            md="2"
                            sm="2"
                            xs="2"
                            class="mt-7"
                            v-if="index > 0"
                          >
                            <v-btn
                              icon
                              color="red"
                              @click="removeIdentificationArr(index)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </template>
                      </v-row>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  class="mt-2"
                  :class="isBirthOriginFulfilled && 'information-fulfilled'"
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    disable-icon-rotate
                  >
                    {{ $t("animal.animalOrigin") }}
                    <template v-slot:actions v-if="isBirthOriginFulfilled">
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="animal-from">
                      <div>
                        <v-row class="pa-5">
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.dateOfBirth") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.birthAndOrigin.dateOfBirth") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-menu
                              v-model="dateOfBirthModel"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="animalToAdd.dateOfBirth"
                                  append-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  v-on:click:append="dateOfBirthModel = true"
                                  :placeholder="$t('selectDate')"
                                  outlined
                                  dense
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="animalToAdd.dateOfBirth"
                                @input="dateOfBirthModel = false"
                                :max="nowDate"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.origin") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.birthAndOrigin.originOfTheAnimal"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-select
                              @input="onAnimalOriginSelect"
                              outlined
                              dense
                              placeholder="Select Origin"
                              :items="getDropDownDataBirthOrigin.animalOrigin"
                              item-text="name"
                              item-value="id"
                              v-model="animalToAdd.animalOriginId"
                            ></v-select>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.farmOfOrigin") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.birthAndOrigin.farmOfOrigin") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              :disabled="isOnTheFarm"
                              type="text"
                              placeholder="e.g. Farm origin"
                              outlined
                              dense
                              v-model="animalToAdd.farmOriginId"
                            ></v-text-field>
                            <!-- <v-select outlined dense placeholder="Select Farm" :items="farms" item-text="farmName" item-value="id" v-model="animalToAdd.farmOriginId"></v-select> -->
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.conceptionMethod") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.birthAndOrigin.conceptionMethod")
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-select
                              outlined
                              dense
                              :placeholder="$t('selectMethod')"
                              :items="
                                getDropDownDataBirthOrigin.conceptionMethod
                              "
                              item-text="name"
                              item-value="id"
                              v-model="animalToAdd.conceptionMethodId"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  class="mt-2"
                  :class="
                    isPercentagePedigreeInformationFilled &&
                    'information-fulfilled'
                  "
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    disable-icon-rotate
                  >
                    {{ $t("animal.parentageAndPedigree") }}
                    <template
                      v-slot:actions
                      v-if="isPercentagePedigreeInformationFilled"
                    >
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="animal-from">
                      <div>
                        <v-row class="pa-5">
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.dashboardS.sireId") }}
                              <v-tooltip right color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span> {{ $t("sireIdT") }} </span>
                              </v-tooltip>
                            </label>
                            <AnimalDropdown
                              v-model="animalToAdd.sireId"
                              animalType="sire"
                            />
                            <!-- <v-select
        v-model="animalToAdd.sireId"
        :items="items"
        label="Select an item"
        item-text="name"
        item-value="id"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            {{ item.name }}
            <v-icon small @click="removeItem(index)">mdi-close</v-icon>
          </v-chip>
        </template>
        <template v-slot:prepend-item>
          <v-text-field
            v-model="animalToAdd.sireId"
            outlined
            placeholder="Custom item"
            @keyup.enter="addCustomItem"
          ></v-text-field>
        </template>
      </v-select> -->
                            <!-- <v-text-field
                              type="text"
                              placeholder="Type ID"
                              outlined
                              dense
                              v-model="animalToAdd.sireId"
                            ></v-text-field> -->
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <div>
                              <label class="subtitle-1 font-weight-medium">
                                {{ $t("animal.dashboardS.damID") }}
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </template>
                                  <span>{{
                                    $t("animal.percentageInformation.damType")
                                  }}</span>
                                </v-tooltip>
                              </label>
                              <AnimalDropdown
                                v-model="animalToAdd.damId"
                                animalType="dam"
                              />
                            </div>
                          </v-col>
                          <!-- <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >Sire ID
                              <v-tooltip right color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  An ID or Registration number of the male
                                  parent of an animal, especially a bull kept
                                  for breeding or bulls semen used for
                                  Artificial Insemination.
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="Type ID"
                              outlined
                              dense
                              v-model="animalToAdd.sireId"
                            ></v-text-field>
                          </v-col> -->
                          <!-- <v-col lg="4" md="6" sm="6" xs="6">
                            <div>
                              <label class="subtitle-1 font-weight-medium"
                                >Dam ID
                                <v-tooltip top color="black" max-width="350">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-help-circle-outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    ID or Registration number of animal's
                                    dam-the female parent of an animal. In case
                                    of Embryo transfer,It's also ID of the dam
                                    who donated an embryo for embryo transfer.
                                  </span>
                                </v-tooltip>
                              </label>
                              <v-text-field
                                type="text"
                                placeholder="e.g. 123"
                                outlined
                                dense
                                v-model="animalToAdd.damId"
                              ></v-text-field>
                            </div>
                          </v-col> -->
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >{{ $t("animal.dashboardS.surrogateId") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>{{ $t("surrogateIDT") }} </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              :placeholder="$t('typeID')"
                              outlined
                              dense
                              v-model="animalToAdd.surrogateId"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  class="mt-2"
                  :class="
                    isOwnerAndBreedAssociationFilled && 'information-fulfilled'
                  "
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    disable-icon-rotate
                  >
                    {{ $t("animal.breedInfo") }}
                    <template
                      v-slot:actions
                      v-if="isOwnerAndBreedAssociationFilled"
                    >
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="animal-from">
                      <div>
                        <!-- <v-row class="pa-5">
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              Stock Brand Number
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Stock brand  is a design that is seared into the hide of an animal, such as cattle to identify the owner of the animals. Color code an animal according to a specific zone
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field type="text" placeholder="e.g. 123" outlined dense v-model="animalToAdd.stockBrandNo"></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              Owner
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Owner
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field type="text" placeholder="e.g. Keith Williams" outlined dense v-model="animalToAdd.owner"></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium"
                              >Breeder/Supplier</label
                            >
                            <v-text-field
                              type="text"
                              placeholder="e.g. Keith Williams"
                              outlined
                              dense
                              v-model="animalToAdd.breederOrSupplier"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              Reg. # in a Breed Association
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Registration number/ ID number of breed Associations/Societies.
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field type="text" placeholder="e.g. 123" outlined dense v-model="animalToAdd.breedAssocRegNo"></v-text-field>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              Name of Breed Association(s)
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Name of Associations/Societies where the animal was registered
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field type="text" placeholder="e.g. Parker Brown" outlined dense v-model="animalToAdd.nameOfBreedAssoc"></v-text-field>
                          </v-col>
                        </v-row> -->
                        <v-row
                          v-for="(info, i) in animalToAdd.ownerBreedAssociation"
                          :key="i"
                        >
                          <v-col
                            lg="4"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="info.stockBrandNo !== 'n/a'"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.dashboardS.stockBrandNumber") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.ownerAndBreed.stockBrandNumber")
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. 123"
                              outlined
                              dense
                              v-model="info.stockBrandNo"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="info.owner !== 'n/a'"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.owner") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.nameOfOwnerAnimal") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. Keith Williams"
                              outlined
                              dense
                              v-model="info.owner"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="4"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="info.breederOrSupplier !== 'n/a'"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.breederSupplier") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("animal.ownerAndBreed.breederSupplier")
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. Keith Williams"
                              outlined
                              dense
                              v-model="info.breederOrSupplier"
                            ></v-text-field>
                          </v-col>

                          <v-col
                            lg="4"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="info.previousOwner !== 'n/a'"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.previosOwner") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("animal.ownerAndBreed.previousOwner") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. Keith Williams"
                              outlined
                              dense
                              v-model="info.previousOwner"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            style="padding-bottom: 0px !important"
                            v-if="i === 0"
                          >
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.BreedAssociation") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.ownerAndBreed.breedAssociationTooltip"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.InABreedAssociation") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.ownerAndBreed.registrationNumber"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. 123"
                              outlined
                              dense
                              v-model="info.breedAssocRegNo"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.nameOfBreedAssociations") }}
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("nameofBreedAssociationT") }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-text-field
                              type="text"
                              placeholder="e.g. Parker Brown"
                              outlined
                              dense
                              v-model="info.nameOfBreedAssoc"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="4" md="6" sm="6" xs="6">
                            <v-spacer></v-spacer>
                            <v-btn
                              v-if="i > 0"
                              style="margin-top: 25px"
                              @click="deleteNewownerAndBreedAssociation(i)"
                              color="red"
                              text
                              ><v-icon>mdi-trash-can-outline</v-icon>
                              {{ $t("remove") }}</v-btn
                            >
                          </v-col>
                        </v-row>
                        <v-btn
                          text
                          @click="addNewownerAndBreedAssociation"
                          color="primary"
                        >
                          <v-icon left> mdi-plus-circle-outline </v-icon>
                          {{ $t("addAnother") }}
                        </v-btn>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  class="mt-2"
                  :class="
                    isAdditionalInformationFilled && 'information-fulfilled'
                  "
                >
                  <v-expansion-panel-header
                    class="subtitle-1"
                    disable-icon-rotate
                  >
                    {{ $t("animal.additionalInfo") }}
                    <template
                      v-slot:actions
                      v-if="isAdditionalInformationFilled"
                    >
                      <v-icon> mdi-pencil </v-icon>
                      <v-icon class="ml-1"> mdi-check </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="animal-from">
                      <div>
                        <v-row class="pa-5">
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.animalPicture") }}

                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.additionalInformation.animalPicture"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <!-- <div class="d-flex justify-space-between" style="padding: 30px;background: #FFFFFF;border: 1px dashed #D2D2D2;
border-radius: 5px;">
                              <a class="mr-1" style="color: #00BD73;">Browse</a>
                              <div> or drag and drop here</div>
                            </div> -->
                            <div v-if="!animalPicture">
                              <div
                                :class="[
                                  'dropZone',
                                  dragging ? 'dropZone-over' : '',
                                ]"
                                @dragenter="dragging = true"
                                @dragleave="dragging = false"
                              >
                                <div
                                  class="dropZone-info"
                                  @drag="onAnimalPictureChange"
                                >
                                  <span
                                    class="fa fa-cloud-upload dropZone-title green--text font-weight-bold"
                                    >{{ $t("browse") }}
                                  </span>
                                  <span class="dropZone-title">
                                    {{ $t("dropHere") }}</span
                                  >
                                </div>
                                <input
                                  type="file"
                                  @change="onAnimalPictureChange"
                                />
                              </div>
                            </div>
                            <div v-else class="dropZone-uploaded">
                              <div class="dropZone-uploaded-info">
                                <!-- <span class="dropZone-title">{{ animalPicture }}</span> -->
                                <img class="image-preview" :src="previewUrl" />
                                <button
                                  type="button"
                                  class="btn btn-primary removeFile"
                                  @click="removeAnimalPicture"
                                >
                                  {{ $t("remove") }}
                                </button>
                              </div>
                            </div>
                          </v-col>
                          <v-col lg="2" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.twin") }}

                              <v-icon class="mb-1">
                                mdi-alert-circle-outline</v-icon
                              ></label
                            >
                            <v-radio-group row v-model="animalToAdd.twin">
                              <v-radio label="Yes" value="1"></v-radio>
                              <v-radio label="No" value="0"></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col
                            lg="3"
                            md="6"
                            sm="6"
                            xs="6"
                            v-if="animalToAdd.twin == 1"
                          >
                            <label class="subtitle-1 font-weight-medium">{{
                              $t("selectGenderCotwin")
                            }}</label>
                            <v-select
                              outlined
                              dense
                              placeholder="e.g. Male"
                              :items="genders"
                              v-model="animalToAdd.additionalInfoGender"
                            ></v-select>
                          </v-col>
                          <v-col lg="3" md="6" sm="6" xs="6">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.hornStatus") }}
                            </label>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-help-circle-outline
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  $t("animal.additionalInformation.hornStatus")
                                }}
                              </span>
                            </v-tooltip>

                            <v-select
                              outlined
                              dense
                              placeholder="e.g. Horned, Polled, Dehorned"
                              :items="hornStatuses"
                              v-model="animalToAdd.hornStatus"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="pa-5">
                          <v-col lg="8" md="8" sm="8" xs="8">
                            <label class="subtitle-1 font-weight-medium">
                              {{ $t("animal.AdditionalNotes") }}

                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t(
                                      "animal.additionalInformation.additionalNotes"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </label>
                            <v-textarea
                              outlined
                              dense
                              :placeholder="$t('typeHere')"
                              v-model="animalToAdd.notes"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-card-text>
        </v-form>
      </v-card>
    </v-container>
    <!-- <primary-geofence-dialog v-if="showPrimaryGeofenceDialog" :dialogI="showPrimaryGeofenceDialog" -->
    <!-- @closeDialog="showPrimaryGeofenceDialog = false"></primary-geofence-dialog> -->
    <create-group-dialog
      @closeDialog="showCreateGroupDialog = false"
      @group:created="onGroupCreated"
      :animalCategories="animalCategories"
      :dialogI="showCreateGroupDialog"
      :newGroupName="newGroupName"
      :speciesTypes="speciesTypes"
      v-if="showCreateGroupDialog"
    />
    <create-group-from-existing-dialog
      v-if="showCreateGroupFromExistingDialog"
      :dialogI="showCreateGroupFromExistingDialog"
      :groups="groups"
      @closeDialog="showCreateGroupFromExistingDialog = false"
      @group:selected="onExistingGroupSelected"
      @new-group:create="onNewGroupCreate"
    >
    </create-group-from-existing-dialog>

    <create-identification-method-dialog
      v-if="showCreateIdentificationMethodDialog"
      @identificationMethod:created="onIdentificationMethodCreated"
      :dialogI="showCreateIdentificationMethodDialog"
      @closeDialog="showCreateIdentificationMethodDialog = false"
    >
    </create-identification-method-dialog>

    <no-farms-dialog
      v-if="showNoFarmDialog"
      :dialogI="showNoFarmDialog"
      @closeDialog="showNoFarmDialog = false"
    >
    </no-farms-dialog>

    <prompt-dialog
      @closeDialog="showPromptDialog = false"
      @saveData="saveFormData"
      :dialogI="showPromptDialog"
      v-if="showPromptDialog"
    />

    <NewZone
      v-if="showPrimaryGeofenceDialog"
      :dialogI="showPrimaryGeofenceDialog"
      :farm-id="+animalToAdd.farmId"
      :location-id="+animalToAdd.locationId"
      @zone:added="onZoneAdded"
      @newZoneClosed="showPrimaryGeofenceDialog = false"
    />

    <ImagePreview
      v-if="showImagePreview"
      :url="previewImage"
      :dialogU="showImagePreview"
      @image-preview-closed="showImagePreview = false"
    />
  </div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
// import PrimaryGeofenceDialog from "./PrimaryGeofenceDialog.vue";
import CreateGroupDialog from "./CreateGroupDialog.vue";
import NewZone from "./NewZone.vue";
import FarmService from "@/_services/farmService";
import S3UploadServce from "@/_services/S3UploadService";
import gql from "graphql-tag";
import moment from "moment";
import { mapGetters } from "vuex";

import CreateGroupFromExistingDialog from "./CreateGroupFromExistingDialog.vue";
import CreateIdentificationMethodDialog from "./CreateIdentificationMethodDialog";
import NoFarmsDialog from "./NoFarmsDialog";
import PromptDialog from "../common/PromptDialog.vue";
import { createBreed, createClass } from "@/graphql/Animals.gql";

import ImagePreview from "@/components/ImagePreview.vue";
import AnimalDropdown from "@/components/AnimalDropdown.vue";

export default {
  apollo: {
    allUserSegments: {
      query: gql`
        query allUserSegments($id: Int!) {
          allUserSegments(id: $id) {
            id
            geofenceName
          }
        }
      `,
      variables() {
        return {
          id: +this.$store.getters.getUser.userDetail.id,
        };
      },
    },
    animalCategories: {
      query: gql`
        query animalCategories {
          animalCategories {
            id
            name
            gender
            specieTypeIds
          }
        }
      `,
      fetchPolicy: "network-only",
      update: data => data.animalCategories,
    },
    breeds: {
      query: gql`
        query breeds {
          breeds {
            classIds
            id
            name
            specieTypeIds
          }
        }
      `,
      update: data => data.breeds,
    },
    classes: {
      query: gql`
        query classes {
          classes {
            id
            gender
            name
            specieTypeIds
          }
        }
      `,
      update: data => data.classes,
    },
    farms: {
      query: gql`
        query farms {
          farms {
            id
            farmName
          }
        }
      `,
      result({ data }) {
        const farms = data.farms;

        if (farms && farms.length) {
          this.animalToAdd.farmId = farms[0].id.toString();
        } else {
          this.showNoFarmDialog = true;
        }
      },
    },
    farmTypes: {
      query: gql`
        query farmTypes {
          farmTypes {
            id
            name
          }
        }
      `,
      update: data => data.farmTypes,
    },
    groups: {
      query: gql`
        query groups {
          groups {
            groupData {
              id
              name
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      update: data => data.groups.groupData,
      result({ data }) {
        this.filterGroups = data.groups.groupData;
      },
    },
    farmLocations: {
      query: gql`
        query framLocations($farmId: Float) {
          farmLocations(farmId: $farmId) {
            id
            address
            farmData {
              farmName
            }
          }
        }
      `,
      variables() {
        return {
          farmId: this.animalToAdd.farmId
            ? Number(this.animalToAdd.farmId)
            : Number(this.primaryFarm.id),
        };
      },
    },
    species: {
      query: gql`
        query species {
          species {
            id
            name
          }
        }
      `,
      update: data => data.species,
    },
    speciesTypes: {
      query: gql`
        query speciesTypes {
          speciesTypes {
            id
            name
            specieId
          }
        }
      `,
      update: data => data.speciesTypes,
    },
    getDropDownDataAnimalIdentification: {
      query: gql`
        query getDropDownDataAnimalIdentification {
          getDropDownDataAnimalIdentification {
            tagCategory {
              id
              name
            }
            additionalIdentificationMethod {
              id
              name
            }
          }
        }
      `,
      update: data => data.getDropDownDataAnimalIdentification,
    },
    getDropDownDataBirthOrigin: {
      query: gql`
        query getDropDownDataBirthOrigin {
          getDropDownDataBirthOrigin {
            animalOrigin {
              id
              name
            }
            conceptionMethod {
              id
              name
            }
          }
        }
      `,
      update: data => data.getDropDownDataBirthOrigin,
    },
  },

  components: {
    // 'primary-geofence-dialog': PrimaryGeofenceDialog,
    "prompt-dialog": PromptDialog,
    "create-group-dialog": CreateGroupDialog,
    "create-group-from-existing-dialog": CreateGroupFromExistingDialog,
    "create-identification-method-dialog": CreateIdentificationMethodDialog,
    "no-farms-dialog": NoFarmsDialog,
    NewZone,
    ImagePreview,
    AnimalDropdown,
  },
  created() {
    if (this.$route.params.farm_number) {
      this.disableFarm = true;
      this.animalToAdd.birthFarmId = this.$route.params.farm_number;
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.promptNextRoute) {
  //     next();
  //   } else {
  //     console.log("hasChanged",this.hasChanged)
  //     if (this.hasChanged) {
  //       this.promptToRoute = to;
  //       this.showPromptDialog = true;
  //     } else {
  //       next();
  //     }
  //   }
  // },
  computed: {
    ...mapGetters(["getUser"]),
    // extension() {
    //   return (this.animalPicture) ? this.animalPicture.name.split('.').pop() : '';
    // }
    hasChanged() {
      return Object.keys(this.animalToAdd).some(field => {
        console.log(this.animalToAdd[field], this.defaultData[field]);
        return this.animalToAdd[field] !== this.defaultData[field];
      });
    },
    getBreeds() {
      if (!this.animalToAdd.speciesTypeId) {
        return;
      }

      const items = this.breeds.filter(breed => {
        return (
          breed.specieTypeIds &&
          breed.specieTypeIds.includes(parseInt(this.animalToAdd.speciesTypeId))
        );
      });
      items.sort(function (a, b) {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
      });
      items.push({ id: "9999", name: "Other" });
      return items;
    },
    getCategories() {
      if (!this.animalToAdd.speciesTypeId) {
        return;
      }

      let filteredBySpecies = this.animalCategories.filter(category => {
        return (
          category.specieTypeIds &&
          category.specieTypeIds?.includes(
            // parseInt(this.animalToAdd.speciesTypeId)
            parseInt(1)
          )
        );
      });
      console.log("filtered", filteredBySpecies);
      let filterByGender = filteredBySpecies.filter(category => {
        return (
          category.gender && category.gender.includes(this.animalToAdd.gender)
        );
      });

      let filterWithDisabled = filterByGender.map(category => {
        return { ...category, disabled: false };
      });

      if (
        this.animalToAdd.animalCategoryId &&
        this.animalToAdd.animalCategoryId.length
      ) {
        let currentCategory = filterWithDisabled.find(
          c => c.id == this.animalToAdd.animalCategoryId
        );
        let disabledMap = [];

        switch (currentCategory.name) {
          case "Other":
            disabledMap = [
              // "Calves",
              "Heifer",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Calves":
            disabledMap = [
              // "Heifer",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              // "Other",
            ];
            break;
          case "Heifer":
            disabledMap = [
              "Calves",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Steer":
            disabledMap = [
              "Heifer",
              "Calves",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Lactating Animals":
            disabledMap = [
              // "Heifer",
              // "Calves",
              "Steer",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Dry Cattle":
            disabledMap = [
              // "Heifer",
              // "Calves",
              "Steer",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Milking Cow":
            disabledMap = [
              "Heifer",
              "Calves",
              "Steer",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Pregnant Cow":
            disabledMap = [
              "Heifer",
              "Calves",
              "Steer",
              "Breeding Bull",
              "Teaser Bull",
              "Scrub Bull",
              "Other",
            ];
            break;
          case "Bull":
            disabledMap = [
              "Heifer",
              // "Calves",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              // "Other",
            ];
            break;
          case "Teaser Bull":
            disabledMap = [
              "Heifer",
              "Calves",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Other",
            ];
            break;
          case "Scrub Bull":
            disabledMap = [
              "Heifer",
              "Calves",
              "Steer",
              "Lactating Cow",
              "Pregnant Cow",
              "Dry Cow",
              "Milking Cow",
              "Other",
            ];
            break;
          default:
            [];
            break;
        }

        filterWithDisabled = filterByGender.map(category => {
          return {
            ...category,
            disabled: disabledMap.includes(category.name) ? true : false,
          };
        });
      }
      return filterWithDisabled;
    },
    getClasses() {
      if (!this.animalToAdd.speciesTypeId || !this.animalToAdd.gender) {
        return;
      }

      const i = this.classes.filter(_class => {
        if (
          _class.specieTypeIds &&
          _class.specieTypeIds.includes(
            parseInt(this.animalToAdd.speciesTypeId)
          )
        ) {
          return _class.gender.includes(this.animalToAdd.gender);
        }

        return false;
      });
      i.push({ id: "9999", name: "Other" });
      return i;
    },
    getSpecies() {
      if (!this.animalToAdd || !this.species) {
        return;
      }

      return this.species.filter(specie => specie.name == "Bovine");
    },
    getSpeciesTypes() {
      if (!this.animalToAdd || !this.animalToAdd.speciesId) {
        return;
      }

      return this.speciesTypes.filter(
        speciesType => speciesType.specieId == this.animalToAdd.speciesId
      );
    },
    isGeneralInfoFulfilled() {
      return (
        this.animalToAdd.animalCategoryId ||
        this.animalToAdd.breedId ||
        this.animalToAdd.classId ||
        this.animalToAdd.speciesId ||
        this.animalToAdd.speciesTypeId ||
        this.animalToAdd.gender
      );
    },
    isBirthOriginFulfilled() {
      return (
        this.animalToAdd.dateOfBirth ||
        this.animalToAdd.animalOriginId ||
        this.animalToAdd.farmOriginId ||
        this.animalToAdd.conceptionMethodId
      );
    },
    isOnTheFarm() {
      return !!(
        this.animalToAdd.animalOriginId &&
        this.animalToAdd.animalOriginId ==
          this.getDropDownDataBirthOrigin.animalOrigin[0].id
      );
    },
    isAnimalIdentificationFilled() {
      return (
        this.animalToAdd.livestockName ||
        this.animalToAdd.govRegistrationNo ||
        this.dateOfRegistrationModel ||
        this.animalToAdd.dateOfRegistration
      );
    },
    isAnimalIdentificationMethodFilled() {
      return (
        this.animalToAdd.identificationMethodsArr.length &&
        (this.animalToAdd.identificationMethodsArr[0].idNumber ||
          this.animalToAdd.identificationMethodsArr[0].chipNumber ||
          this.animalToAdd.identificationMethodsArr[0].tag ||
          this.animalToAdd.identificationMethodsArr[0].position ||
          this.animalToAdd.identificationMethodsArr[0].tagColor ||
          this.animalToAdd.identificationMethodsArr[0].image ||
          this.animalToAdd.identificationMethodsArr[0].tagNumber ||
          this.animalToAdd.identificationMethodsArr[0].tatooName ||
          this.animalToAdd.identificationMethodsArr[0].brandName ||
          this.animalToAdd.identificationMethodsArr[0].code ||
          this.animalToAdd.identificationMethodsArr[0].tagCategoryId)
      );
    },
    isPercentagePedigreeInformationFilled() {
      return (
        this.animalToAdd.sireId ||
        this.animalToAdd.damId ||
        this.animalToAdd.surrogateId
      );
    },
    isOwnerAndBreedAssociationFilled() {
      return (
        this.animalToAdd.ownerBreedAssociation[0].stockBrandNo ||
        this.animalToAdd.ownerBreedAssociation[0].owner ||
        this.animalToAdd.ownerBreedAssociation[0].breederOrSupplier ||
        this.animalToAdd.ownerBreedAssociation[0].previousOwner ||
        this.animalToAdd.ownerBreedAssociation[0].breedAssocRegNo ||
        this.animalToAdd.ownerBreedAssociation[0].nameOfBreedAssoc
      );
    },
    isAdditionalInformationFilled() {
      return (
        this.animalPicture ||
        this.animalToAdd.additionalInfoGender ||
        this.animalToAdd.notes ||
        this.animalToAdd.twin ||
        this.animalToAdd.hornStatus
      );
    },
    getTodayDate() {
      return moment().format("YYYY-MM-DD");
    },

    getFarmList() {
      const role = this.$store.getters.getUser.userDetail.role;
      let farmList = this.farms;
      if (role && role == "farmer" && this.primaryFarm) {
        farmList = this.farms.filter(item => item.id == this.primaryFarm.id);
      }
      return farmList;
    },

    farmLocationFilter() {
      return this.farmLocations?.map(item => {
        return {
          id: item.id,
          address: item?.farmData?.farmName + " / " + item.address,
        };
      });
    },
  },

  async mounted() {
    console.log("USERssssssssssss===============>>>>>>>>>>>>>>>", this.getUser);
    this.defaultData = { ...this.animalToAdd };

    if (this.type && this.type.toLowerCase() === "group") {
      this.showCreateGroupFromExistingDialog = true;
    }

    const { data } = await FarmService.getPrimaryFarm();
    if (data) {
      this.primaryFarm = data;
      console.log("primaryfarm", this.primaryFarm);
      this.farmZones = this.primaryFarm.GeoFences;
      this.filterZones = this.primaryFarm.GeoFences;
    }
  },
  data() {
    return {
      showImagePreview: false,
      previewImage: "",
      breedName: "",
      className: "",
      zoneNames: [],
      filterGroups: [],
      nowDate: new Date().toISOString().slice(0, 10),
      showNoFarmDialog: false,
      categorySearch: null,
      classSearch: null,
      primaryFarm: null,
      newGroupName: null,
      showCreateIdentificationMethodDialog: false,
      farmZones: [],
      animalCategories: [],
      breeds: [],
      classes: [],
      dateOfBirthModel: false,
      dateOfRegistrationModel: false,
      farmTypes: [],
      groups: [],
      getDropDownDataAnimalIdentification: [],
      getDropDownDataBirthOrigin: [],
      species: [],
      speciesTypes: [],
      showPrimaryGeofenceDialog: false,
      showCreateGroupDialog: false,

      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
      defaultData: {},

      showCreateGroupFromExistingDialog: false,
      zoneSearchTerm: "",
      groupSearchTerm: "",
      filterZones: [],
      selectedFruits: [],
      filteredCategories: [],
      animalRules: {
        breed: [v => !!v || "Breed is required"],
        pregnancyStatus: [v => !!v || "Pregnancy Status is required"],
        category: [v => !!v || "Category is required"],
        class: [v => !!v || "Class is required"],
        damId: [v => !!v || "Dam ID is required"],
        dateOfRegistration: [v => !!v || "Date of registration is required"],
        dateOfBirth: [v => !!v || "Date of brith is required"],
        farm: [v => !!v || "Farm is required"],
        gender: [v => !!v || "Gender is required"],
        livestockName: [v => !!v || "Livestock Name is required"],
        sireId: [v => !!v || "Sire ID is required"],
        species: [v => !!v || "Species is required"],
        speciesType: [v => !!v || "Species Type is required"],
        breedName: [
          v =>
            (!!v && this.animalToAdd.breedId == "9999") ||
            "Breed Name required",
        ],
        className: [
          v =>
            (!!v && this.animalToAdd.classId.includes("9999")) ||
            "Class Name required",
        ],
      },
      animalProfile: null,
      previewUrl: null,
      animalPicture: "",
      dragging: false,
      panel: 0,
      valid: true,
      disableFarm: false,
      animalDOBmenu: false,
      animalRemovalmenu: false,
      imageRules: [
        value =>
          !value ||
          value.size < 1000000 ||
          "Avatar size should be less than 1 MB!",
      ],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("animals"),
          to: {
            name: "Animals",
          },
          exact: true,
        },
        {
          text: this.$t("animal.addNewAnimal"),
          disabled: true,
        },
      ],
      openRequired: false,
      errors: {
        animalImg: "",
        animalCategoryId: "",
        classId: "",
        tagType: "",
        tagNumber: "",
        registrationNumber: "",
        birthWeight: "",
        birthEase: "",
        birthFarmId: "",
        ownerName: "",
        sirePubId: "",
        damPubId: "",
        surrogateDamPubId: "",
        breed: "",
        conceptionMethod: "",
        gender: "",
        dob: "",
        operator: "",
        animalRemovedFarmId: "",
        animalRemovalDate: "",
        removedAnimalDestination: "",
        animalRemovalReason: "",
        name: "",
        trackingNumber: "",
        brand: "",
        tattoo: "",
        hornStatus: null,
        origin: "",
        previousOwnerName: "",
        twin: "",
        breedAssociationName: "",
        breedAssociationRegNo: "",
        breeder: "",
        note: "",
      },
      birthEaseTypes: [
        { text: this.$t("animal.noAssistance"), value: "1" },
        { text: this.$t("animal.someAssistance"), value: "2" },
        { text: this.$t("animal.mechanicalAssistance"), value: "3" },
        { text: this.$t("animal.aCesareanSection"), value: "4" },
        { text: this.$t("animal.abnormalDelivery"), value: "5" },
      ],
      genders: [
        { text: this.$t("animal.male"), value: "Male" },
        { text: this.$t("animal.female"), value: "Female" },
      ],
      animalRemovalReasons: [
        { text: this.$t("animal.sale"), value: "1" },
        { text: this.$t("animal.slaughter"), value: "2" },
        { text: this.$t("animal.death"), value: "3" },
        { text: this.$t("animal.theft"), value: "4" },
        { text: this.$t("animal.other"), value: "5" },
      ],
      hornStatuses: [
        { text: this.$t("animal.horned"), value: "Horned" },
        { text: this.$t("animal.polled"), value: "Polled" },
        { text: this.$t("animal.dehorned"), value: "Dehorned" },
      ],
      bullTypes: [
        { text: this.$t("animal.breeding"), value: "Breeding" },
        { text: this.$t("animal.teaser"), value: "Teaser" },
        { text: this.$t("animal.steer"), value: "Steer" },
        { text: this.$t("animal.other"), value: "Other" },
      ],

      pregnancyStatus: [
        { text: this.$t("animal.yes"), value: "Yes" },
        { text: this.$t("animal.no"), value: "No" },
        { text: this.$t("animal.noClue"), value: "No Clue" },
      ],

      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      animalToAdd: {
        animalCategoryId: null,
        breedId: null,
        classId: null,
        groupId: null,
        farmId: null,
        locationId: null,
        farmTypeId: null,
        speciesId: null,
        speciesTypeId: null,
        bullType: null,
        pregnancyStatus: null,
        animalImg: "",
        tagType: "plastic",
        tagNumber: "",
        registrationNumber: "",
        birthWeight: "",
        birthEase: "1",
        birthFarmId: "",
        ownerName: "",
        sirePubId: "",
        damPubId: "",
        surrogateDamPubId: "",
        breed: "",
        conceptionMethod: "1",
        gender: null,
        dob: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        operator: "",
        animalRemovedFarmId: "",
        animalRemovalDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        removedAnimalDestination: "Test Destination",
        animalRemovalReason: "1",
        name: "",
        trackingNumber: "",
        identificationMethodsArr: [
          {
            additionalIdentificationMethodId: 1,
            idNumber: null,
            chipNumber: null,
            tagColor: null,
            imageUrl: null,
            tagNumber: null,
            tatooName: null,
            brandName: null,
            code: null,
            position: null,
            tagCategoryId: null,
          },
        ],
        brand: "",
        tattoo: "",
        hornStatus: null,
        origin: "",
        previousOwnerName: "",
        twin: "",
        breedAssociationName: "",
        breedAssociationRegNo: "",
        breeder: "",
        note: "",
        ownerBreedAssociation: [
          {
            stockBrandNo: "",
            owner: "",
            breederOrSupplier: "",
            previousOwner: "",
            breedAssocRegNo: "",
            nameOfBreedAssoc: "",
          },
        ],
      },
    };
  },

  methods: {
    // addCustomSireItem() {
    //   if (this.customInput) {
    //     const newItem = {
    //       id: this.items.length + 1,
    //       name: this.customInput,
    //     };
    //     this.items.push(newItem);
    //     this.selectedItem = newItem;
    //     this.customInput = '';
    //   }
    // },
    // removeItem(index) {
    //   this.items.splice(index, 1);
    //   this.selectedItem = null;
    // },

    showImage(url) {
      this.previewImage = url;
      this.showImagePreview = true;
    },
    opendFile(ref) {
      this.$refs[ref][0].click();
    },

    async removeFile(index) {
      this.animalToAdd.identificationMethodsArr =
        await this.animalToAdd.identificationMethodsArr.map((a, i) =>
          i == index ? { ...a, imageUrl: null } : a
        );
    },
    async replaceFile(index, ref) {
      this.animalToAdd.identificationMethodsArr =
        await this.animalToAdd.identificationMethodsArr.map((a, i) =>
          i == index ? { ...a, imageUrl: null } : a
        );
      this.$refs[ref][0].click();
    },
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (answer) {
        console.log(
          "saving.......NEED TO WORK IN CONCEPT OF DRAFT IS IMPLEMENTED",
          answer
        );
        this.registerAnimal();
      } else {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    addNewownerAndBreedAssociation() {
      this.animalToAdd.ownerBreedAssociation.push({
        stockBrandNo: "n/a",
        owner: "n/a",
        breederOrSupplier: "n/a",
        previousOwner: "n/a",
        breedAssocRegNo: "",
        nameOfBreedAssoc: "",
      });
    },
    deleteNewownerAndBreedAssociation(i) {
      this.animalToAdd.ownerBreedAssociation.splice(i, 1);
    },
    async createNewBreed() {
      return this.$apollo
        .mutate({
          mutation: createBreed,
          variables: {
            createBreedInput: {
              name: this.breedName,
              classId: parseInt(this.animalToAdd.classId),
              specieTypeId: parseInt(this.animalToAdd.speciesTypeId),
            },
          },
        })
        .then(({ data }) => {
          this.animalToAdd.breedId = data.createBreed.id;
          return Promise.resolve();
        })
        .catch(e => Promise.reject(e));
    },
    async createNewClass() {
      return this.$apollo
        .mutate({
          mutation: createClass,
          variables: {
            createClassInput: {
              name: this.className,
              gender: this.animalToAdd.gender,
              specieTypeId: parseInt(this.animalToAdd.speciesTypeId),
            },
          },
        })
        .then(({ data }) => {
          console.log("dd", data);
          this.animalToAdd.classId.push(data.createClass.id);

          const index = this.animalToAdd.classId.indexOf("9999");

          if (index > -1) {
            // only splice array when item is found
            this.animalToAdd.classId.splice(index, 1); // 2nd parameter means remove one item only
          }
          return Promise.resolve();
        })
        .catch(e => Promise.reject(e));
    },
    onAnimalOriginSelect() {
      if (this.isOnTheFarm) {
        this.animalToAdd.farmOriginId = this.primaryFarm.farmName;
      } else {
        this.animalToAdd.farmOriginId = "";
      }
    },
    removeIdentificationArr(indentIndex) {
      this.animalToAdd.identificationMethodsArr.splice(indentIndex, 1);
    },
    addToIdentificationArr() {
      this.animalToAdd.identificationMethodsArr.push({
        additionalIdentificationMethodId: 1,
        idNumber: null,
        chipNumber: null,
        tagColor: null,
        imageUrl: null,
        tagNumber: null,
        tatooName: null,
        brandName: null,
        code: null,
        position: null,
        tagCategoryId: null,
      });
    },
    async onAnimalTatooPictureChange(index, e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.startLoading();
      // console.log("here is file", files[0]);
      let uploadedTatooImageUrl = await this.uploadTatooImage(files[0]);
      // let uploadedTatooImageUrl = "https://livestock-be-s3-dev.s3.us-west-1.amazonaws.com/tatoo/1669894803538-Screenshot-2022-11-28-17:58:55.png"
      // console.log("uploaded tatoo url", uploadedTatooImageUrl);
      this.animalToAdd.identificationMethodsArr =
        await this.animalToAdd.identificationMethodsArr.map((a, i) =>
          i == index ? { ...a, imageUrl: uploadedTatooImageUrl } : a
        );
      console.log(this.animalToAdd.identificationMethodsArr);
      this.stopLoading();
    },
    async uploadTatooImage(imageObj) {
      let uploadedImage;
      if (imageObj && typeof imageObj == "object") {
        //file and folder to aws
        console.log("img obje", imageObj);
        uploadedImage = await S3UploadServce.singleUpload(imageObj, "tatoo");
      }
      console.log("uploadedImage", uploadedImage);
      return uploadedImage ? uploadedImage.fullPath : "";
    },
    onCategorySelect() {
      this.$apollo.queries.animalCategories.skip = false;
      this.$apollo.queries.animalCategories.refetch();
    },
    onClassSelect() {
      //
    },
    onExistingGroupSelected(existingGroupId) {
      if (existingGroupId) {
        this.animalToAdd.groupId = existingGroupId;
        this.showCreateGroupFromExistingDialog = false;
      }
    },
    onNewGroupCreate(newGroupName) {
      if (newGroupName) {
        this.newGroupName = newGroupName;
        this.showCreateGroupFromExistingDialog = false;
        this.showCreateGroupDialog = true;
      }
    },
    async onZoneAdded(zoneName) {
      const { data } = await FarmService.getPrimaryFarm();
      this.primaryFarm = data;
      console.log("primaryfarm", this.primaryFarm);
      this.farmZones = await FarmService.getAllZonesByLocationId(
        Number(this.animalToAdd.locationId)
      );
      this.farmZones = this.farmZones.data;
      this.filterZones = this.farmZones;

      this.animalToAdd.zoneId = this.farmZones.find(
        zone => zoneName.toLowerCase() == zone.geofenceName.toLowerCase()
      ).id;
    },
    searchZones() {
      this.filterZones = this.farmZones.filter(zone => {
        return (
          zone.geofenceName
            .toLowerCase()
            .indexOf(this.zoneSearchTerm.toLowerCase()) > -1
        );
      });
    },
    searchGroups() {
      this.filterGroups = this.groups.filter(group => {
        return (
          group.name.toLowerCase().indexOf(this.groupSearchTerm.toLowerCase()) >
          -1
        );
      });
    },
    showHideSection(section) {
      var panel = this.$refs[section];
      panel.style.maxHeight = panel.style.maxHeight
        ? null
        : panel.scrollHeight + "%";
    },
    async registerAnimal() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();
      if (this.animalToAdd.classId?.includes("9999")) {
        try {
          await this.createNewClass();
        } catch (e) {
          console.log("Class Create Error", e);
        }
      }

      // Check if selected Other
      // if(this.animalToAdd.breedId == '9999') {
      //   try{
      //     await this.createNewBreed()
      //   }catch(e) {
      //     console.log('Breed Create Error', e)
      //   }
      // }

      let formData = new FormData();
      console.log(this.animalToAdd.zoneId);
      console.log(this.primaryFarm);

      if (this.animalToAdd.breedId == "9999") {
        formData.breedName = this.breedName;
      }

      formData.animalCategoryId = this.animalToAdd.animalCategoryId
        ? [+this.animalToAdd.animalCategoryId]
        : null;
      // formData.animalCategoryId = this.animalToAdd.animalCategoryId.map(
      //   (categoryId) => parseInt(categoryId)
      // );
      formData.breedId =
        this.animalToAdd.breedId && this.animalToAdd.breedId !== "9999"
          ? parseInt(this.animalToAdd.breedId)
          : null;
      formData.classId = this.animalToAdd.classId
        ? this.animalToAdd.classId.map(classId => parseInt(classId))
        : null;
      // formData.farmTypeId = this.animalToAdd.farmTypeId ? parseInt(this.animalToAdd.farmTypeId) : null;
      formData.groupId = this.animalToAdd.groupId
        ? this.animalToAdd.groupId.map(item => parseInt(item))
        : null;
      formData.speciesId = this.animalToAdd.speciesId
        ? parseInt(this.animalToAdd.speciesId)
        : null;
      formData.speciesTypeId = this.animalToAdd.speciesTypeId
        ? parseInt(this.animalToAdd.speciesTypeId)
        : null;
      formData.gender = this.animalToAdd.gender;
      // formData.farmId = this.primaryFarm ? parseInt(this.primaryFarm.id) : null;
      formData.farmId = this.animalToAdd.farmId
        ? parseInt(this.animalToAdd.farmId)
        : null;

      formData.locationId = this.animalToAdd.locationId
        ? parseInt(this.animalToAdd.locationId)
        : null;

      formData.zoneId = this.animalToAdd.zoneId
        ? parseInt(this.animalToAdd.zoneId)
        : null;
      (formData.bullType = this.animalToAdd.bullType),
        (formData.pregnancyStatus = this.animalToAdd.pregnancyStatus),
        (formData.animalIdentification = {
          livestockName: this.animalToAdd.livestockName,
          govRegistrationNo: this.animalToAdd.govRegistrationNo,
          dateOfRegistration: this.animalToAdd.dateOfRegistration,
          identificationMethods: this.animalToAdd.identificationMethodsArr,
        }),
        (formData.birthOrigin = {
          animalOriginId: this.animalToAdd.animalOriginId
            ? parseInt(this.animalToAdd.animalOriginId)
            : null,
          dateOfBirth: this.animalToAdd.dateOfBirth,
          farmId: this.animalToAdd.farmOriginId,
          conceptionMethodId: this.animalToAdd.conceptionMethodId
            ? parseInt(this.animalToAdd.conceptionMethodId)
            : null,
          userId: parseInt(this.getUser.userDetail.id),
        });

      formData.parentageInformation = {
        surrogateId: this.animalToAdd.surrogateId || null,
        damId: this.animalToAdd.damId ? this.animalToAdd.damId : null,
        sireId: this.animalToAdd.sireId,
      };
      formData.ownerBreedAssociation = [
        ...this.animalToAdd.ownerBreedAssociation,
      ];
      // formData.ownerBreedAssociation = {
      //   stockBrandNo: this.animalToAdd.stockBrandNo,
      //   breedAssocRegNo: this.animalToAdd.breedAssocRegNo,
      //   owner: this.animalToAdd.owner,
      //   breederOrSupplier: this.animalToAdd.breederOrSupplier,
      //   nameOfBreedAssoc: this.animalToAdd.nameOfBreedAssoc,
      // }
      let uploadedImage;
      if (this.animalPicture && typeof this.animalPicture == "object") {
        //file and folder to aws
        uploadedImage = await S3UploadServce.singleUpload(
          this.animalPicture,
          "registration"
        );
        this.animalPicture = uploadedImage.fullPath;
      }
      formData.additionalInformation = {
        animalPicture: this.animalPicture || null,
        gender: this.animalToAdd.additionalInfoGender,
        hornStatus: this.animalToAdd.hornStatus,
        notes: this.animalToAdd.notes,
        twin: !!this.animalToAdd.twin,
      };
      formData.removalInformation = {};

      formData.append("animalImg", this.animalPicture);
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateGeneralInformationInput!) {
              createGeneralInformation(createGeneralInformationInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: formData,
          },
        })
        // AnimalService.registerAnimal(formData)
        .then(async res => {
          this.promptNextRoute = true;
          console.log(res);
          if (
            res.data.createGeneralInformation &&
            res.data.createGeneralInformation.id
          ) {
            this.stopLoading();

            this.$notify({
              title: "Animal Added",
              text: res.message,
              type: "success",
            });

            this.$router.push({
              name: "AnimalDetails",
              params: { animal_number: res.data.createGeneralInformation.id },
            });
          } else {
            this.$notify({
              title: "Animal Not Added",
              text: res.message,
              type: "error",
            });
            this.stopLoading();
          }
        })
        .catch(error => {
          if (error.status == 422) {
            error.data.message.errors.forEach(err => {
              this.errors[err.param] = err.msg;
            });
          }
          this.stopLoading();
        });
    },

    async onGroupCreated(newGroup) {
      await this.$apollo.queries.groups.refetch();

      this.animalToAdd.groupId = [newGroup.id.toString()];
    },

    async onIdentificationMethodCreated() {
      await this.$apollo.queries.getDropDownDataAnimalIdentification.refetch();
    },

    onAnimalPictureChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.previewUrl = URL.createObjectURL(files[0]);
      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.createAnimalPicture(files[0]);
    },
    async parseFile(file) {
      return new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.readAsText(file);
        fr.onload = () => {
          resolve(fr.result);
        };
        fr.onerror = reject;
      });
    },
    async createAnimalPicture(file) {
      this.animalPicture = file;
      this.dragging = false;
    },
    removeAnimalPicture() {
      this.animalPicture = "";
    },
    async changeCategories(value) {
      console.log(value);
    },
    async fetchLocationZones(locationId) {
      this.farmZones = await FarmService.getAllZonesByLocationId(
        Number(locationId)
      );
      this.farmZones = this.farmZones.data;
      this.filterZones = this.farmZones;
    },
  },
  mixins: [loading],
  props: {
    type: {
      required: false,
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.v-expansion-panel-header {
  //background: #e5f8f1;
  background: #f3f3f380;
  border-radius: 5px;
  justify-content: space-between;
}

.v-expansion-panel-header--active {
  background: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  color: #787878;
  font-size: 18px;
}

.birth-origin,
.general-information {
  .v-expansion-panel-header {
    background: #fff7ec;
  }
}

.information-fulfilled {
  .v-expansion-panel-header,
  .v-expansion-panel-header--active {
    background: #e5f8f1;
  }
}

.birth-origin-fulfilled,
.general-information-fulfilled {
  .v-expansion-panel-header,
  .v-expansion-panel-header--active {
    background: #e5f8f1;
  }
}

.birth-origin-not-fulfilled,
.general-information-not-fulfilled {
  .v-expansion-panel-header,
  .v-expansion-panel-header--active {
    background: #fdebeb;
  }
}

.dropZone {
  position: relative;
  padding: 30px;
  background: #ffffff;
  border: 1px dashed #d2d2d2;
  border-radius: 5px;
}

.dropZone:hover {
  border: 2px solid #00bd73;
}

.dropZone:hover .dropZone-title {
  color: #00bd73;
}
.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  padding: 30px;
  background: #ffffff;
  border-radius: 5px;
  position: relative;
  border: 1px dashed #eee;
}

.removeFile {
  color: red;
  margin-left: 15px;
}

.file-btn {
  position: relative;
  float: right;
  margin-top: -60px;
  right: 5px;
  color: #00bd73;
  cursor: pointer;
}
.file-btn1 {
  position: relative;
  float: right;
  margin-top: -60px;
  margin-right: 65px;
  color: #00bd73;
  cursor: pointer;
}
.file-btn2 {
  position: relative;
  float: right;
  margin-top: -60px;
  right: 5px;
  color: red;
  cursor: pointer;
}
.v-input__control .v-text-field__details {
  display: none !important;
}
.additional-ids .col-lg-4 {
  padding: 0px 12px;
}
:deep(.v-autocomplete:not(.v-input--is-focused).v-select--chips input) {
  max-height: 25px !important;
}

.nowrap-label {
  white-space: nowrap;
}
</style>
